import MR from 'js/services/map_requests'

import {iconFF9800, icon00BCD4, icon9E9E9E,
  iconF44336, iconE91E63, icon9C27B0, icon673AB7, icon3F51B5,
  icon2196F3, icon03A9F4, iconCDDC39, icon009688, icon4CAF50,
  icon8BC34A, iconFFEB3B, iconFFC107, iconFF5722, icon795548,
  icon607D8B, findIconColor} from '../../lib/constants/icon_pdv'

  const enrollableIcon = require('assets/images/ico-point-of-sale-enrollable.svg')
  const nonEnrollableIcon = require('assets/images/ico-point-of-sale-non_enrollable.svg')

export default {
  methods: {
    /*
     * Asigna el marcador creado a un punto de venta
     */
    onPointOfSalesMarkerAdd(marker) {
      const point = this.pointsOfSales.find(
        pointOfSales => pointOfSales.id === marker.target.options.icon.options.data.id
      )

      this.$set(point, 'marker', marker)
    },

    /*
     * Muestra un popup con la información del punto de venta seleccionado
     */
    showPopup(element) {
      const popupTemplate = require('./popup.pug'); // eslint-disable-line
      const pointOfSales = element.target.options.icon.options.data

      const validEnrollmentCapacities = [1, 2, 3]

      const enrollmentCapacity = validEnrollmentCapacities
        .includes(pointOfSales.enrollment_capacity) ?
        pointOfSales.enrollment_capacity :
        null

      const capacity = (
        pointOfSales.capacity_code > 0 || enrollmentCapacity.toString() === '3') ?
        '3' :
        enrollmentCapacity

      console.log(capacity, 'capacity');

      // Si no hay un popup previo asociado, creamos uno nuevo
      if (!element.target.popup) {
        const popupData = {
          name: pointOfSales.spot_name,
          enrollment_capacity: capacity,
          address: pointOfSales.address,
          comuna_name: pointOfSales.comuna_name,
          phone: pointOfSales.phone,
          schedule: pointOfSales.schedule,
          capacity_code: pointOfSales.capacity_code,
          capacity_description: pointOfSales.capacity_description
        }

        const popup = L.popup({
          closeButton: false,
          offset: L.point(17, 6) // Centrar el popup en el marcador, default: L.point(0, 6)
        }).setContent(popupTemplate(popupData))

        element.target.unbindPopup()
        element.target.bindPopup(popup).openPopup()
      } else {
        // Si ya hay un popup simplemente lo volvemos a abrir
        element.target.popup.openPopup()
      }
    },

    /*
     * Devuelve el icono de los puntos de venta para usarlo en el mapa
     */
    pointOfSalesIcon(pointOfSales) {
      const iconType = MR.getPointOfSalesIcon(pointOfSales)
      let icon
      if (iconType === 'additional_capabilities') {
        const icon_color = findIconColor(
          pointOfSales.id,
          pointOfSales.capacity_code,
          pointOfSales.capacity_description,
          pointOfSales.enrollment_capacity
        )
        icon = this.selectIcon(icon_color)
      } else if (iconType === 'enrollable') {
        icon = enrollableIcon
      } else {
        icon = nonEnrollableIcon
      }

      const PointIcon = L.Icon.extend({
        options: {
          data: null,
          iconUrl: icon,
          iconAnchor: [18, 18],
          popupAnchor: [-18, -19]
        }
      })

      return new PointIcon({
        data: {
          id: pointOfSales.id,
          spot_name: pointOfSales.spot_name,
          enrollment_capacity: pointOfSales.enrollment_capacity,
          address: pointOfSales.address,
          comuna_name: pointOfSales.comuna_name,
          phone: pointOfSales.phone,
          schedule: pointOfSales.schedule,
          capacity_code: pointOfSales.capacity_code,
          capacity_description: pointOfSales.capacity_description
        }
      })
    },

    /*
     * Devuelve el nombre de icono de los puntos de venta para usarlo en el sidepanel
     */
    pointOfSalesIconName(pointOfSales) {
      if (pointOfSales.capacity_code > 0 || pointOfSales.enrollmentCapacity.toString() === '3') {
        return 'additional-capabilities'
      }

      return pointOfSales.enrollment_capacity ? 'point-of-sale text-info' : 'recharge'
    },

    selectIcon(color){
      switch (color) {
        case '9E9E9E':
          return icon9E9E9E
        case 'FF9800':
          return iconFF9800
        case 'F44336':
          return iconF44336
        case 'E91E63':
          return iconE91E63
        case '9C27B0':
          return icon9C27B0
        case '673AB7':
          return icon673AB7
        case '3F51B5':
          return icon3F51B5
        case '2196F3':
          return icon2196F3
        case '03A9F4':
          return icon03A9F4
        case 'CDDC39':
          return iconCDDC39
        case '009688':
          return icon009688
        case '4CAF50':
          return icon4CAF50
        case '8BC34A':
          return icon8BC34A
        case 'FFEB3B':
          return iconFFEB3B
        case 'FFC107':
          return iconFFC107
        case 'FF5722':
          return iconFF5722
        case '795548':
          return icon795548
        case '795548':
          return icon607D8B
        default:
          return icon00BCD4
      }
    }
  }
}
